<template>
  <Layout>
    <Title :height="28" imgUrl="url('@/assets/img/bg-serv-white-title.svg')">
      <img src="@/assets/img/contratualista-title-logo.svg" class="h-44 w-auto" alt="Contratualista Service logo" />
    </Title>
    <About
      title="Escreva e apresente os melhores contratos para seus clientes"
      text="Com o Contratualista Service, você compõe, edita e interpreta contratos sem deixar qualquer ponta solta, para ter mais confiança e melhor apresentação ao cliente."
      service="contratualista"
    />
    <Benefits :solutionId="11" />
    <PlansComparison :solution-id="11" />
    <Solutions title="Mais soluções" />
    <Depoimentos title="Depoimentos" />
    <Faq title="Perguntas Frequentes" :questions="faqStore.questions" />
  </Layout>
</template>

<script lang="ts" setup>
import Layout from '@/components/BaseLayout/Layout.vue';
import Title from '@/components/Title/Title.vue';
import Benefits from '@/components/Benefits/Benefits.vue';
import PlansComparison from '@/components/Plans/PlansComparison.vue';
import Solutions from '@/components/Solutions/Solutions.vue';
import Depoimentos from '@/components/Depoimentos/Depoimentos.vue';
import Faq from '@/components/Faq/Faq.vue';
import { useFaqStore } from '@/store/faqStore';
import About from '@/components/About/About.vue';

const faqStore = useFaqStore();
</script>
